/**
 * 피그마 기준 캔버스 360×780에 맞춘 뷰포트 단위.
 * - 가로: N px → calc(100vw * N / 360)  (360폭에서 1vw ≈ 3.6px)
 * - 세로: N px → calc(100dvh * N / 780) (780높이에서 1dvh ≈ 7.8px)
 *
 * sx / style 또는 MUI theme override에서 import 해 사용하세요.
 */
export const DESIGN_BASE_WIDTH = 360;
export const DESIGN_BASE_HEIGHT = 780;

/** 피그마 가로 px → vw 기반 길이 */
export function pxW(n) {
    return `calc(100vw * ${n} / ${DESIGN_BASE_WIDTH})`;
}

/** 피그마 세로 px → dvh 기반 길이 */
export function pxH(n) {
    return `calc(100dvh * ${n} / ${DESIGN_BASE_HEIGHT})`;
}

/**
 * 가로·세로 모두 피그마에서 온 “같은 스케일”이면 보통 pxW 사용.
 * 세로 전용(화면 높이 비율) 레이아웃에만 pxH 사용.
 */
export function paddingWH(t, r, b, l) {
    const top = typeof t === 'number' ? pxH(t) : t;
    const right = typeof r === 'number' ? pxW(r) : r;
    const bottom = typeof b === 'number' ? pxH(b) : b;
    const left = typeof l === 'number' ? pxW(l) : l;
    return `${top} ${right} ${bottom} ${left}`;
}
